var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.626 13.7998L3.5 16.9998L6 18.4998L7.5 20.9998L11.399 16.9048",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6006 16.9048L17.4996 20.9998L18.9996 18.4998L21.4996 16.9998L18.3736 13.7998",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4497 5.04976C20.1834 7.78343 20.1834 12.2156 17.4497 14.9493C14.7161 17.6829 10.2839 17.6829 7.55025 14.9493C4.81658 12.2156 4.81658 7.78343 7.55025 5.04976C10.2839 2.31609 14.7161 2.31609 17.4497 5.04976",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4994 12.5843L14.2964 13.5283C14.6464 13.7123 15.0554 13.4153 14.9884 13.0253L14.6454 11.0243L16.0994 9.60829C16.3824 9.33229 16.2264 8.85129 15.8354 8.79429L13.8264 8.50229L12.9284 6.68129C12.7534 6.32629 12.2484 6.32629 12.0734 6.68129L11.1754 8.50229L9.1654 8.79529C8.7744 8.85229 8.6184 9.33329 8.9014 9.60929L10.3554 11.0253L10.0124 13.0263C9.9454 13.4163 10.3544 13.7133 10.7044 13.5293L12.5014 12.5853H12.4994V12.5843Z",
    stroke: "#D0D5DD",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTier);
export default __webpack_public_path__ + "static/media/tier.2aa20119e4e65081919048561d6c74bd.svg";
export { ForwardRef as ReactComponent };